export default function validateForm(
  name: string,
  groupId: string,
  showName: boolean | undefined,
  showLevel: boolean | undefined
) {
  return (showName ? !!name && name.length >= 2 : true) && (showLevel ? !!groupId : true);
}
